var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2327 10.94H21.9162L19.5738 12.9196V15.9047L21.6674 14.1219H21.7659L21.6519 20.7916C21.6519 21.1181 21.4809 21.4187 21.201 21.5897C19.4753 22.6521 13.2876 26.4508 12.562 26.4508C11.7173 26.4508 11.0384 25.7667 11.0384 24.9272V15.1947C11.0384 14.0287 11.6655 12.9559 12.6812 12.3858L23.6834 6.20847L12.505 0L1.65836 6.01154C0.632248 6.5816 0 7.65953 0 8.83074V19.4701C0 20.5999 0.606336 21.6415 1.5858 22.2064L10.2974 27.2022C11.8261 28.078 13.7073 28.0677 15.2258 27.1763L23.5227 22.2893C24.4711 21.7296 25.0567 20.7087 25.0567 19.6101V11.764C25.0567 11.3131 24.6888 10.9451 24.2379 10.9451L24.2327 10.94Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebar);
export default __webpack_public_path__ + "static/media/logo-sidebar.ae9547d08ac93953aea0398e221cfc74.svg";
export { ForwardRef as ReactComponent };